import { render, staticRenderFns } from "./LineaTiempoB.vue?vue&type=template&id=9573b1a4&lang=pug&"
import script from "./LineaTiempoB.vue?vue&type=script&lang=js&"
export * from "./LineaTiempoB.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports